import { render, staticRenderFns } from "./DetailBillByStudent.vue?vue&type=template&id=63edce2c&scoped=true&"
import script from "./DetailBillByStudent.vue?vue&type=script&lang=js&"
export * from "./DetailBillByStudent.vue?vue&type=script&lang=js&"
import style0 from "./DetailBillByStudent.vue?vue&type=style&index=0&id=63edce2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63edce2c",
  null
  
)

export default component.exports